import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-influencer-analytics',
  templateUrl: './influencer-analytics.component.html',
  styleUrls: ['./influencer-analytics.component.scss']
})
export class InfluencerAnalyticsComponent implements OnInit {
  @Input() influencerData = [];

  constructor() { }

  ngOnInit(): void {
  }

}
